<template>
    <div class="position-relative top-0 start-0 w-100 d-flex align-items-center" style="height: 100vh">
        <div class="row justify-content-center w-100">
            <button class="btn col-12 col-lg-3 pt-4 pb-4 text-center userbtn m-2 fw-bold" @click="goto('teacher')">我是老師</button>
            <button class="btn col-12 col-lg-3 pt-4 pb-4 text-center userbtn m-2 fw-bold"  @click="goto('student')">我是學生</button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SelectUser',
    methods: {
        goto(user){
            console.log(user)
            switch(user){
                case "teacher":
                    this.$router.push('/test_in_class_teacher')
                    break
                case "student":
                    this.$router.push('/test_in_class_student')
                    break
                default: 
                    this.$router.push('/test_in_class_student')
                    break
            }
        }
    }
}
</script>
<style>
.userbtn{
    background-color: #C4C4C4 !important;
    border-radius: 10px;
}
</style>